import React from "react";
import { cn } from "@/lib/utils";

export const PageHeader = ({ title, subtitle, actions, eyebrow, className = "", testId = "page-header" }) => (
  <div className={cn("flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between", className)} data-testid={testId}>
    <div className="min-w-0">
      {eyebrow && <div className="og-section-label mb-1">{eyebrow}</div>}
      <h1 className="font-heading text-2xl font-semibold tracking-tight text-foreground md:text-[28px]" data-testid={`${testId}-title`}>{title}</h1>
      {subtitle && <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </div>
);
